import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { GetByPatientActionStatusEnum, PatientRequiringActionControllerApi } from "../../../services";
import { DGT_Pagination, getConfigObject, getPageIndexWhileSearch, getXtenantId, useBaseContent } from "../../../utils/utils";

interface UseRequiringActionProps {
    patient: string,
    pagination: DGT_Pagination;
    startDate?: string;
    endDate?: string;
    status?: GetByPatientActionStatusEnum;
}

/**
 *
 * @author [Rajkumar Rathod]
 */
export function usePatientRequiringAction(
    props: UseRequiringActionProps
): useBaseContent<any> {
    const prevPage = useRef<number>(props.pagination.page);

    const pageIndex = getPageIndexWhileSearch({
        pagination: props.pagination,
        prevPage: prevPage,
    });

    const pageSize = props.pagination.pageSize;
    return useQuery({
        queryKey: [
            "patient-requiring-action",
            pageSize,
            pageIndex,
            props,
        ],
        enabled: !!props.patient,
        placeholderData: keepPreviousData,
        refetchOnWindowFocus: false,
        queryFn: async () => {
            return new PatientRequiringActionControllerApi(getConfigObject())
                .getByPatient(
                    props.patient,
                    pageIndex, //page
                    pageSize, //size
                    undefined, //sortBy
                    undefined, //sortDirection
                    props.status ?? undefined, //actionStatus
                    props.startDate, //startDate
                    props.endDate, //endDate
                    getXtenantId(), //xTENANTID
                )
                .then((it) => it?.data);
        },
    });
};
